import { VTable } from 'roosterjs-editor-dom';
import { cacheGetContentSearcher, clearContentSearcherCache } from 'roosterjs-editor-core';
import { editTable, formatTable, replaceWithNode } from 'roosterjs-editor-api';
import { Paste } from 'roosterjs-editor-plugins';
import PluginUtils from '../store/schema/PluginUtils';

export default function createPluginUtils(pastePlugin: Paste): PluginUtils {
    return {
        cacheGetContentSearcher,
        clearContentSearcherCache,
        replaceWithNode,
        editTable,
        formatTable,
        pasteOriginal: clipboardData => pastePlugin.pasteOriginal(clipboardData),
        pasteText: clipboardData => pastePlugin.pasteText(clipboardData),
        createVTable: (td: HTMLTableCellElement) => new VTable(td),
    };
}
